<template>
  <IncomingStorageDetail :is-edit="true" />
</template>

<script>
import IncomingStorageDetail from './detail';

export default {
  name: 'IncomeStorageEdit',
  components: { IncomingStorageDetail },
};
</script>

<style scoped>

</style>
